export function index()
{
    return axios.get(route('api.manage.countries'))
        .then(({data}) => data);
}
